
import { observable, action } from 'mobx';
import { plainToClassFromExist } from 'class-transformer';

import LoginService from '../../service/login/LoginService';
/**
 * 获取登录二维码数据结构
 *
 ***/
export class DataLogCodeModel {
    @observable public base64: string;
    @observable public barcode: string;

    // @action public init(param: any) {
    //     return LoginService.getCode(param).then((res) => {
    //         plainToClassFromExist(this, res);
    //         return res;
    //     });
    // }
    // todo 重写获取二维码方式
    @action public async init() {
       const res = await LoginService.getCodeIdaas();

       return res
    }

}

/*

    获取二维码使用状态--轮询结果
*/

export class DataLogCodeStatus {
    @observable public barcode: string; // 二维码的标识，用于后续查询二维码状态
    @observable public st: string; // 确认登录的状态，该字段不为空  登录之前为空
    @observable public status: number;  // 0-初始化,1-已扫码，2已授权,3-放弃授权

    @action public init(securityStr: string, barcode: string, businessId) {
        return LoginService.getCodeStatus(securityStr, barcode, businessId).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }

}

/*
    获取登录token
*/

export class DataLoginToken {
    @observable public token: string; // Token

    @action public init(loginParam) {
        return LoginService.verifyPhoneCodeLogin(loginParam).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }

}

/* 登录IM */

export class DataLoginIM{
    @observable public token: string; // Token
    @observable public userName: string; // Token
    @observable public password: string; // Token
    @action public loginIM(){
        return LoginService.loginIM().then((res)=>{
            plainToClassFromExist(this, res);
            return res;
        })
    }
}

/**
 * 获取手机验证码
 */
export class GetPhoneCode {
    @observable public data: {
        dayLeftCount: 0,
    };
    @action public init(param) {
        return LoginService.getPhoneCode(param).then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

/**
 * 判断用户是否登录
 */
export class HasLogin {
    @action public init() {
        return LoginService.hasLogin().then((res) => {
            plainToClassFromExist(this, res);
            return res;
        });
    }
}

/**
 * 退出登录
 */
export class Logout {
    @action public init() {
        return LoginService.logout().then((res) => {
            return res;
        });
    }
}

/**
 * 系统权限判断
 */
export class isAuthority {
    @action public init() {
        return LoginService.isAuthority().then(res => {
            plainToClassFromExist(this, res);
            return res;
        })
    }
}